/**
 * New Outcome Driver Page
 *
 * Renders QuickDriverMode directly inside the PrioritizationLayout,
 * bypassing the legacy mode-selection screen and legacy dark header.
 *
 * Route: /prioritization/outcome-drivers/new
 */

import { useNavigate, useSearchParams } from 'react-router-dom';
import { QuickDriverMode } from '@/features/outcome-drivers/QuickDriverMode';

export default function NewOutcomeDriverPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const cycleId = searchParams.get('cycleId');
  const cycleName = searchParams.get('cycleName');
  // After saving, always return to the outcome drivers list (or to the cycle if cycle-linked)
  const returnUrl = cycleId
    ? `/prioritization/cycles/${cycleId}`
    : '/prioritization/outcome-drivers';

  return (
    <QuickDriverMode
      onBack={() => navigate('/prioritization/outcome-drivers')}
      cycleId={cycleId}
      cycleName={cycleName}
      returnUrl={returnUrl}
    />
  );
}
